import React from "react";
import { Link } from "react-router-dom";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const ServicesDropdown = ({ ClickHandler, ServicesData }) => {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // format slug: removes hyphens, replaces & with "And", camelCase
  const formatSlug = (text) => {
    if (!text) return "";
    return text
      .replace(/&/g, "And")
      .replace(/-/g, " ")
      .replace(/[^a-zA-Z0-9 ]/g, "")
      .split(" ")
      .map((word, i) =>
        i === 0
          ? word.toLowerCase()
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join("");
  };

  const themeColors = {
    primary: "var(--primary-color)",
    secondary: "#262b3e",
    midBlue: "#687693",
    lightGray: "#edecec",
    white: "#fff",
  };

  return (
    <div style={{ padding: "5px 0" }}>
      <div
        style={{
          textAlign: "center",
          marginBottom: "30px",
          padding: "10px",
          background: themeColors.primary,
          borderRadius: "5px",
          cursor: "pointer",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          transition: "all 0.3s ease",
        }}
        onClick={ClickHandler}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
        }}
      >
        <Typography
          variant="h5"
          style={{
            color: themeColors.white,
            fontWeight: 500,
            letterSpacing: "0.5px",
            fontFamily: "'Roboto Slab', serif",
          }}
        >
          All Services
        </Typography>
      </div>

      <div className="widget service-list-widget" style={{ marginTop: "16px" }}>
        {ServicesData.map((service, idx) => (
          <Accordion
            key={service.Id || idx}
            expanded={expanded === service.Id}
            onChange={handleChange(service.Id)}
            elevation={0}
            sx={{
              marginBottom: "12px",
              borderRadius: "5px !important",
              border: `1px solid ${themeColors.lightGray}`,
              overflow: "hidden",
              transition: "all 0.3s ease",
              "&:before": {
                display: "none",
              },
              "&:hover": {
                borderColor: themeColors.white,
                boxShadow: `0 4px 12px rgba(201, 179, 140, 0.2)`,
              },
              "&.Mui-expanded": {
                margin: "0 0 12px 0",
                borderColor: themeColors.white,
                boxShadow: `0 4px 16px rgba(201, 179, 140, 0.25)`,
              },
            }}
          >
            <AccordionSummary
              expandIcon={
                <ExpandMoreIcon
                  sx={{
                    color: themeColors.secondary,
                    fontSize: "24px",
                    fontWeight: "bold",
                    transition: "all 0.3s ease",
                  }}
                />
              }
              sx={{
                backgroundColor: themeColors.white,
                padding: "0px 20px",
                minHeight: "60px !important",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "var(--primary-color)",
                  "& .MuiTypography-root": {
                    color: `${themeColors.white} !important`,
                  },
                  "& .MuiSvgIcon-root": {
                    color: `${themeColors.white} !important`,
                  },
                },
                "&.Mui-expanded": {
                  minHeight: "60px !important",
                  backgroundColor: "var(--primary-color)",
                  "& .MuiTypography-root": {
                    color: themeColors.white,
                  },
                  "& .MuiSvgIcon-root": {
                    color: themeColors.white,
                  },
                },
                "& .MuiAccordionSummary-expandIconWrapper": {
                  transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                },
                "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                  transform: "rotate(180deg)",
                },
              }}
            >
              <Typography
                component={Link}
                to={`/service-category/${formatSlug(service.sTitle)}`}
                onClick={(e) => {
                  e.stopPropagation();
                  ClickHandler();
                }}
                sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                  color: themeColors.secondary,
                  fontFamily: "'Roboto Slab', serif",
                  letterSpacing: "0.3px",
                  transition: "color 0.3s ease",
                  textDecoration: "none",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                {service.sTitle}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: "15px 24px",
                backgroundColor: themeColors.lightGray,
                borderTop: `2px solid ${themeColors.primary}`,
              }}
            >
              <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
                {[
                  service.sub1,
                  service.sub2,
                  service.sub3,
                  service.sub4,
                  service.sub5,
                ].map(
                  (sub, i) =>
                    sub && (
                      <li
                        key={i}
                        style={{
                          marginBottom: i < 4 ? "12px" : 0,
                          transition: "all 0.2s ease",
                        }}
                      >
                        <Link
                          onClick={ClickHandler}
                          to={`/services/${formatSlug(sub)}`}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            textDecoration: "none",
                            color: themeColors.midBlue,
                            padding: "10px 12px",
                            borderRadius: "6px",
                            transition: "all 0.3s ease",
                            fontSize: "15px",
                            fontWeight: 500,
                            backgroundColor: themeColors.white,
                            border: `1px solid transparent`,
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor =
                              themeColors.white;
                            e.currentTarget.style.color = themeColors.secondary;
                            e.currentTarget.style.paddingLeft = "20px";
                            e.currentTarget.style.borderColor =
                              themeColors.primary;
                            e.currentTarget.style.boxShadow =
                              "0 2px 8px rgba(201, 179, 140, 0.3)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor =
                              themeColors.white;
                            e.currentTarget.style.color = themeColors.midBlue;
                            e.currentTarget.style.paddingLeft = "12px";
                            e.currentTarget.style.borderColor = "transparent";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <ChevronRightIcon
                            sx={{
                              fontSize: "20px",
                              marginRight: "8px",
                              color: themeColors.primary,
                              transition: "transform 0.3s ease",
                            }}
                          />
                          {sub}
                        </Link>
                      </li>
                    )
                )}
              </ul>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </div>
  );
};

export default ServicesDropdown;
